import arrow_vue_vue_type_script_setup_true_lang_default from "./arrow.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/popper/src/arrow.vue
var arrow_default = arrow_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { arrow_default as default };
//# sourceMappingURL=arrow2.mjs.map